import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  placeholder: {
    width: "100%",
  },
}));

export default useStyles;
